import { useList } from '@/src/hooks/useList';
import { UTxOWithDetails } from '@/src/lib/MayzSmartDB/Commons/index';
import { TokenMetadataApi } from '@/src/lib/MayzSmartDB/FrontEnd/index';
import { useAppStore } from '@/src/store/global';
import { UTxO } from '@lucid-evolution/lucid';
import { useEffect, useState } from 'react';

export const useDetailsUTxOs = ({ uTxOs }: { uTxOs: UTxO[] }) => {
    //--------------------------------------
    const [isRefreshing, setIsRefreshing] = useState(true);
    useEffect(() => {
        setIsRefreshing(false);
    }, []);
    //--------------------------------------
    const appStore = useAppStore();
    //--------------------------------------
    const loadList = async () => {
        const uTxOsWithDetails = await Promise.all(
            uTxOs.map(async (key) => {
                const assetWithDetails = await TokenMetadataApi.getAssetsWithDetailsApi(key.assets);
                return {
                    ...key,
                    assetWithDetails,
                    hasScriptRef: key.scriptRef !== undefined ? 'Yes' : 'No',
                };
            })
        );
        return uTxOsWithDetails;
    };
    //--------------------------------------
    const { isLoadingList, isLoadedList, list, current, refreshList } = useList<UTxOWithDetails>({ nameList: 'UTxOWithDetails', loadList });
    //--------------------------------------
    return {
        //--------------------------------------
        appStore,
        isRefreshing,
        isLoadingList,
        isLoadedList,
        uTxOsWithDetails: list,
        refreshList,
    };
    //--------------------------------------
};
